<template>
  <div class="add-account-overlay" v-if="visible" @click.self="$emit('close')">
    <div class="add-account-popup">
      <div class="add-account-card">
        <div class="add-account-title">添加数字货币</div>

        <div class="add-account-row add-account-row-selected">
          <img class="add-account-icon" src="/static/newImg/bank/icon/icon_hb.svg" />
          <span class="add-account-row-text">USDT</span>
        </div>

        <div class="add-account-row add-account-row-selected">
          <img class="add-account-icon" src="/static/newImg/bank/icon/icon_bzbh.svg" />
          <span class="add-account-row-text">TRC20</span>
        </div>

        <div class="add-account-input-wrap">
          <input
            class="add-account-input"
            v-model="address"
            type="text"
            placeholder="请输入数字货币地址"
          />
          <span class="add-account-paste" @click="onPaste">粘贴</span>
        </div>

        <div class="add-account-tip">
          请确认币种、协议与地址匹配，否则无法到账
        </div>

        <div class="add-account-confirm" :class="{ disabled: submitting }" @click="onConfirm">
          {{ submitting ? '提交中...' : '确定' }}
        </div>
      </div>

      <div class="add-account-close" @click="$emit('close')">
        <svg viewBox="0 0 24 24" width="32" height="32">
          <circle cx="12" cy="12" r="10" fill="none" stroke="#fff" stroke-width="1.5"/>
          <line x1="8" y1="8" x2="16" y2="16" stroke="#fff" stroke-width="1.5"/>
          <line x1="16" y1="8" x2="8" y2="16" stroke="#fff" stroke-width="1.5"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddCryptoPopup',
  props: {
    visible: { type: Boolean, default: false },
    // 提现密码（明文）：每次点击添加时弹密码框验证通过后由父组件传入，失败重试不用再弹
    password: { type: String, default: '' },
  },
  data() {
    return {
      address: '',
      submitting: false,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.address = '';
        this.submitting = false;
      }
    },
  },
  methods: {
    // 统一 toast：向上级联找 App.vue 的 showTost(type, msg)，不会被当前弹框遮罩挡住
    toast(msg, type = 0) {
      let p = this.$parent;
      while (p) {
        if (typeof p.showTost === 'function') {
          p.showTost(type, msg);
          return;
        }
        p = p.$parent;
      }
      if (this.$notify) {
        this.$notify({ type: type ? 'success' : 'danger', message: msg, zIndex: 999999, duration: 2500 });
        return;
      }
      if (this.$toast) {
        try { this.$toast({ message: msg, zIndex: 999999, position: 'top' }); } catch (_) { this.$toast(msg); }
        return;
      }
      this._domToast(msg);
    },
    _domToast(msg) {
      try {
        if (!msg) return;
        const el = document.createElement('div');
        el.textContent = msg;
        Object.assign(el.style, {
          position: 'fixed', top: '40%', left: '50%', transform: 'translateX(-50%)',
          background: 'rgba(0,0,0,0.78)', color: '#fff', padding: '0.24rem 0.35rem',
          borderRadius: '0.1rem', fontSize: '0.3rem', zIndex: '999999',
          maxWidth: '80%', textAlign: 'center', pointerEvents: 'none',
        });
        document.body.appendChild(el);
        setTimeout(() => { try { document.body.removeChild(el); } catch (_) {} }, 1500);
      } catch (_) {}
    },
    onPaste() {
      if (navigator.clipboard && navigator.clipboard.readText) {
        navigator.clipboard.readText().then((text) => {
          if (text) this.address = text;
        }).catch(() => {
          this.toast('请手动粘贴');
        });
      } else {
        this.toast('请手动粘贴');
      }
    },
    onConfirm() {
      if (this.submitting) return;
      if (!this.address.trim()) {
        this.toast('请输入数字货币地址');
        return;
      }
      const needReauth = (msg) => /提现密码/.test(msg || '');
      this.submitting = true;
      const that = this;
      this.$apiFun
        .post('/api/userCards/add', {
          type: 2,
          coin_name: 'USDT',
          chain_type: 'TRC20',
          wallet_address: this.address.trim(),
          wallet_owner: '',
          password: this.password,
        })
        .then((res) => {
          that.submitting = false;
          if (res.code === 200) {
            that.toast('提交成功', 1);
            that.$emit('added');
            that.$emit('close');
          } else {
            const msg = res.message || res.msg || '提交失败';
            that.toast(msg);
            if (needReauth(msg)) {
              that.$emit('close');
              that.$emit('needReauth');
            }
          }
        })
        .catch(() => {
          that.submitting = false;
          that.toast('网络异常，请稍后重试');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.add-account-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-account-popup {
  width: 92%;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.add-account-card {
  width: 92%;
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 0.2rem;
  padding: 0.4rem 0.35rem;
}

.add-account-title {
  text-align: center;
  font-size: 0.38rem;
  color: #fff;
  font-weight: bold;
  margin-bottom: 0.35rem;
}

.add-account-row {
  display: flex;
  align-items: center;
  background: rgb(0 0 0 / 5%);
  border: 1px solid #666;
  border-radius: 0.1rem;
  padding: 0.2rem 0.25rem;
  margin-bottom: 0.2rem;
}

.add-account-row-selected {
  background: rgb(0 0 0 / 5%);
}

.add-account-row-dropdown {
  position: relative;
  justify-content: space-between;
}

.add-account-row-left {
  display: flex;
  align-items: center;
}

.add-account-row-arrow {
  transition: transform .2s ease;
  flex-shrink: 0;
}

.add-account-row-arrow.open {
  transform: rotate(180deg);
}

.add-account-row-text.placeholder {
  color: #666;
}

.add-account-icon {
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.15rem;
}

.add-account-row-text {
  font-size: 0.3rem;
  color: #fff;
}

.add-account-select-dropdown {
  position: absolute;
  left: -1px;
  right: -1px;
  top: 100%;
  margin-top: 2px;
  background: #2b2b2b;
  border: 1px solid #444;
  border-radius: 0.1rem;
  max-height: 8rem;
  overflow-y: auto;
  z-index: 10;
  box-shadow: 0 6px 16px rgba(0,0,0,.4);
}

.add-account-select-option {
  padding: 0.22rem 0.25rem;
  font-size: 0.3rem;
  color: #ccc;
  border-bottom: 1px solid #333;
}
.add-account-select-option:last-child { border-bottom: none; }
.add-account-select-option:hover,
.add-account-select-option.active {
  color: #d1ae52;
  background: rgba(209,174,82,0.08);
}

.add-account-input-wrap {
  display: flex;
  align-items: center;
  background: rgb(0 0 0 / 5%);
  border: 1px solid #666;
  border-radius: 0.1rem;
  padding: 0 0.25rem 0 0.25rem;
  margin-bottom: 0.2rem;
}

.add-account-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 0.3rem;
  padding: 0.1rem 0;
  height: 0.9rem;

  &::placeholder {
    color: #666;
  }
}

.add-account-paste {
  color: #d1ae52;
  font-size: 0.28rem;
  cursor: pointer;
  padding-left: 0.15rem;
}

.add-account-tip {
  font-size: 0.28rem;
  color: #d1ae52;
  margin: 0.25rem 0;
  line-height: 1.4;
}

.add-account-confirm {
  width: 100%;
  background: #d1ae52;
  color: #703904;
  text-align: center;
  font-size: 0.35rem;
  padding: 0.25rem 0;
  border-radius: 0.1rem;
  cursor: pointer;
  margin-top: 0.3rem;
  letter-spacing: 0.15rem;
}

.add-account-close {
  margin-top: 0.5rem;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/view/withdraw/AddCryptoPopup.vue